// Symbol Option Component for mobile dropdown
const SymbolOption = ({ symbol, selected, onSelect, disabled, tickIconSrc }) => (
    <div
      onClick={() => !disabled && onSelect(symbol)}
      className={`cursor-pointer px-4 py-3 flex items-center transition-all border-b border-[#E9DFF6] ${selected ? 'bg-[#753ABF]/10' : 'hover:bg-gray-50'
        } ${disabled && !selected ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      <div className="flex items-center justify-center bg-[#753ABF] rounded-full w-12 h-12 mr-4">
        <img src={symbol.image} alt={symbol.label} className="w-8 h-8" />
      </div>
      <p className="text-[#4A2D7F] font-semibold flex-1 leading-snug">{symbol.label}</p>
      {selected && (
        tickIconSrc ? (
          <img src={tickIconSrc} alt="selected" className="w-6 h-6" />
        ) : (
          // <svg className="w-6 h-6 text-[#753ABF]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          //   <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
          //   <circle cx="12" cy="12" r="11" strokeWidth="2" />
          // </svg>
          <img src={tickIconSrc} alt="selected" className="w-6 h-6" />
        )
      )}
    </div>
  );

export default SymbolOption;